"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var Ingredient_1 = require("./Ingredient");
/**
 * @author Adam Drda
 */


var Recipe =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Recipe, _DomainObject_1$Domai);

  /**
   *
   * @param id
   * @param externalId
   * @param productId
   * @param amountToMake amount of servings
   * @param ingredients products used for making the recipe
   */
  function Recipe(id, externalId, productId, amountToMake) {
    var _this;

    var ingredients = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : immutable_1.List.of();

    _classCallCheck(this, Recipe);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Recipe).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.productId = productId;
    _this.amountToMake = amountToMake;
    _this.ingredients = ingredients;
    return _this;
  }

  return Recipe;
}(DomainObject_1.DomainObject);

exports.Recipe = Recipe;

Recipe.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Recipe.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    productId: builder.str('productId'),
    amountToMake: builder.num('amountToMake'),
    ingredients: builder.listOf(builder.obj('ingredients', Ingredient_1.Ingredient.schema, function (mat) {
      return new Ingredient_1.Ingredient(mat.externalId, mat.productId, mat.amount);
    }))
  };
}();